import gql from 'graphql-tag';
import { UserAllDataFragment } from '../fragments';

export default gql`
mutation updateUserPermissions (
    $id: ID!
    $permissions: [Permission]!
) {
    updateUserPermissions (
        id: $id,
        permissions: $permissions
    ) {
        ...UserAllDataFragment
    }
}
${UserAllDataFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/updateUserPermissions.ts